import CurrencyFormatter from "@lmn/brg-ui-currency-formatter";

const locale = "de-DE";
const currency = "EUR";

export function formatPrice(price: number) {
  const cf = new CurrencyFormatter(locale, currency);
  const roundedPrice = Math.round(price);
  return cf.formatNumberToFloor(roundedPrice);
}

export function formatPriceWithDecimals(price: number) {
  const cf = new CurrencyFormatter(locale, currency);
  return cf.formatNumber(price);
}

export const formatPriceDiff = (diff: number): string => {
  if (diff === 0) return "+ 0";
  const sign = diff > 0 ? "+" : "-";
  return `${sign}${formatPrice(Math.abs(diff))}`;
};
